module.exports = __webpack_public_path__ + "img/icon-arrow.73c1f51b.svg";